import { useState, type FormEvent, type JSX } from 'react';

import { api } from '../lib/api';
import { useBesedila } from '../lib/jezik';

interface Lastnosti {
  /** Poklicano po uspešni prijavi, da se aplikacija osveži. */
  naPrijavo: () => void;
}

/**
 * Stran za prijavo.
 *
 * Sporočilo ob napaki je enako, kot ga vrne strežnik — vedno „napačna e-pošta
 * ali geslo", tudi če uporabnika ni. Iz vmesnika ne sme biti mogoče ugotoviti,
 * kateri naslovi obstajajo.
 */
export function Prijava({ naPrijavo }: Lastnosti): JSX.Element {
  const b = useBesedila();
  const [email, setEmail] = useState('');
  const [geslo, setGeslo] = useState('');
  const [napaka, setNapaka] = useState<string | null>(null);
  const [poslji, setPoslji] = useState(false);

  const oddaj = (dogodek: FormEvent): void => {
    dogodek.preventDefault();
    setPoslji(true);
    setNapaka(null);
    api
      .prijava(email, geslo)
      .then(naPrijavo)
      .catch((e: unknown) => {
        setNapaka(e instanceof Error ? e.message : b.prijavaNiUspela);
      })
      .finally(() => {
        setPoslji(false);
      });
  };

  return (
    <main className="prijava">
      <h1>{b.znamka}</h1>
      <p className="podnaslov">{b.podnaslov}</p>

      <section className="kartica">
        <h2>{b.prijava}</h2>
        <form onSubmit={oddaj} className="obrazec">
          <label>
            {b.ePosta}
            <input
              type="email"
              value={email}
              autoComplete="username"
              onChange={(d) => {
                setEmail(d.target.value);
              }}
              required
              autoFocus
            />
          </label>
          <label>
            {b.geslo}
            <input
              type="password"
              value={geslo}
              autoComplete="current-password"
              onChange={(d) => {
                setGeslo(d.target.value);
              }}
              required
            />
          </label>
          {napaka !== null && <p className="napaka">{napaka}</p>}
          <button type="submit" disabled={poslji || email === '' || geslo === ''}>
            {poslji ? b.prijavljam : b.prijava}
          </button>
        </form>
      </section>

      <p className="drobno">{b.dostopOdpre}</p>
    </main>
  );
}
